// @flow
import config from "@config";
export type AbsenceReviewUISchemaArgs = $Exact<{
  monitoringType: "BASIC" | "STREAMLINED" | "DETAILED",
  readonly: boolean,
  supportActionsTaken: boolean,
  t: (s: string) => string,
}>;

export default ({
  monitoringType,
  readonly,
  t,
  supportActionsTaken,
}: AbsenceReviewUISchemaArgs) => ({
  deferActionReason: {},
  noActionReason: {},
  newLevel: {
    ...(readonly
      ? {
          "ui:widget": "hidden",
        }
      : {}),
  },
  currentLevel: {
    ...(!readonly
      ? {
          "ui:widget": "hidden",
        }
      : {}),
  },
  additionalSupportActionsTaken: {
    "ui:options": {
      label: !readonly || supportActionsTaken ? t("STEP_ADDITIONAL_SUPPORT_ACTIONS") : null,
    },
    "ui:field": "multi-select",
  },
  meetingDate: {
    "ui:widget": "date-picker",
    "ui:options": {
      dateFormat: "DD/MM/YYYY",
      placeholder: "dd/mm/yyyy",
      dateFormat: config.dateFormatBE,
    },
  },
  nextReviewDate: {
    "ui:widget": "date-picker",
    "ui:options": {
      dateFormat: "DD/MM/YYYY",
      placeholder: "dd/mm/yyyy",
      dateFormat: config.dateFormatBE,
    },
  },
  ...(monitoringType === "DETAILED"
    ? {
        completedTasks: {
          items: {
            id: {
              "ui:options": {
                hidelabel: true,
              },
            },
          },
          "ui:options": {
            addButtonTitle: "Add",
          },
        },
      }
    : {
        completedTasks: {
          "ui:widget": "hidden",
        },
      }),
  notes: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5,
    },
  },
  "ui:order": ["action", "*", "notes"],
  "ui:layoutFlexRatio": "1/1", // label/field
});
